var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-item"},[_c('label',{staticClass:"service-item-date"},[_vm._v(_vm._s(_vm._f("formatServiceDate")(_vm.service.date)))]),_c('label',{staticClass:"service-item-qualification"},[_vm._v(_vm._s(_vm.service.qualification_label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }